module.exports = __webpack_public_path__ + "media/images/lb/506-5df80adafb55653916f8cce63996402d.svg";